import styled from 'styled-components'

import { FormSubmit } from '../../../../../form/FormSubmit'

export const CtaButton = styled(FormSubmit)`
  margin: ${props => props.theme.spacing(4)} 0;
  width: 100%;
`
